import { render, staticRenderFns } from "./ApplicationList.vue?vue&type=template&id=21cd9f2d&scoped=true&"
import script from "./ApplicationList.vue?vue&type=script&lang=js&"
export * from "./ApplicationList.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/user-list.scss?vue&type=style&index=0&id=21cd9f2d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cd9f2d",
  null
  
)

export default component.exports